export default __webpack_public_path__ + "static/media/tos.a97105c3.pdf";